const { set, transform } = require('lodash');
const flatten = require('flat');
const defaultTheme = require('@cld/themes');

const generateNewTheme = () =>
  transform(
    flatten(defaultTheme),
    (obj, _, path) => {
      set(obj, path.split('.'));
    },
    {}
  );

export default generateNewTheme;
